export const p1DefaultStyles = {
  color: "var(--theme-email-p1-color-text)",
  fontFamily: "var(--theme-email-p1-font-family)",
  fontWeight: "var(--theme-email-p1-font-weight)",
  fontSize: "var(--theme-email-p1-font-size)",
  lineHeight: "var(--theme-email-p1-line-height)",
  letterSpacing: "var(--theme-email-p1-letter-spacing)",
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  margin: {
    marginTop: "12",
    marginBottom: "12",
    marginLeft: "24",
    marginRight: "24",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;

export const p2DefaultStyles = {
  color: "var(--theme-email-p2-color-text)",
  fontFamily: "var(--theme-email-p2-font-family)",
  fontWeight: "var(--theme-email-p2-font-weight)",
  fontSize: "var(--theme-email-p2-font-size)",
  lineHeight: "var(--theme-email-p2-line-height)",
  letterSpacing: "var(--theme-email-p2-letter-spacing)",
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  margin: {
    marginTop: "12",
    marginBottom: "12",
    marginLeft: "24",
    marginRight: "24",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;

export const p3DefaultStyles = {
  color: "var(--theme-email-p3-color-text)",
  fontFamily: "var(--theme-email-p3-font-family)",
  fontWeight: "var(--theme-email-p3-font-weight)",
  fontSize: "var(--theme-email-p3-font-size)",
  lineHeight: "var(--theme-email-p3-line-height)",
  letterSpacing: "var(--theme-email-p3-letter-spacing)",
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  margin: {
    marginTop: "12",
    marginBottom: "12",
    marginLeft: "24",
    marginRight: "24",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;
